import script from "./ConnectionFailed.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConnectionFailed.vue?vue&type=script&setup=true&lang=ts"

import "./ConnectionFailed.vue?vue&type=style&index=0&id=66d1f184&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66d1f184"]])

export default __exports__